import React from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export const FinalCTA = () => {
  const trackCheckout = (planName: string, price: number) => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: planName,
        value: price,
        currency: 'ARS'
      });
    }
  };
  return <section className="py-20 md:py-32 px-4 bg-navy-950 relative overflow-hidden" data-id="element-86">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(255,165,0,0.1),transparent_70%)] pointer-events-none" data-id="element-87"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-transparent to-transparent" data-id="element-88"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-89">
        <FadeIn data-id="element-90">
          <h2 className="text-xs md:text-sm font-black tracking-[0.3em] text-red-500 uppercase mb-10 bg-red-500/10 inline-block px-6 py-2 rounded-full border border-red-500/20" data-id="element-91">
            ⏰ EL PRECIO CIERRA EN:
          </h2>
          <div className="mb-20" data-id="element-92">
            <CountdownTimer data-id="element-93" />
          </div>

          <div className="space-y-8 max-w-3xl mx-auto mb-20" data-id="element-94">
            <div className="bg-navy-900/60 p-8 md:p-12 rounded-[2.5rem] border border-white/10 hover:border-orange-500/30 transition-all duration-500 shadow-2xl backdrop-blur-md group" data-id="element-95">
              <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-96">
                <div className="text-left" data-id="element-97">
                  <h4 className="text-2xl md:text-3xl text-white mb-3 group-hover:text-orange-400 transition-colors font-[900] font-[Montserrat,_sans-serif]" data-id="element-98">
                    📘 MÉTODO SILENCIO TOTAL
                  </h4>
                  <p className="text-base text-gray-400 mb-4 font-sans tracking-wide" data-id="element-99">
                    5 Tomos + 4 Bonos · Perros en departamentos
                  </p>
                  <div className="flex items-baseline gap-4" data-id="element-100">
                    <span className="text-gray-500 line-through text-lg font-bold" data-id="element-101">
                      $69.000
                    </span>
                    <span className="text-4xl md:text-5xl font-black text-orange-400 drop-shadow-[0_0_15px_rgba(255,165,0,0.3)]" data-id="element-102">
                      $19.990{' '}
                      <span className="text-lg text-orange-200/60" data-id="element-103">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48701651583193:1" className="w-full md:w-auto text-lg px-10 py-6" onClick={() => trackCheckout('MÉTODO SILENCIO TOTAL', 19990)} data-id="element-104">
                  QUIERO MI MÉTODO SILENCIO TOTAL
                </Button>
              </div>
            </div>

            <div className="bg-gradient-to-br from-navy-800 to-navy-950 p-8 md:p-12 rounded-[2.5rem] border-2 border-orange-500/50 shadow-[0_0_60px_rgba(255,165,0,0.2)] relative overflow-hidden group" data-id="element-105">
              <div className="absolute top-0 right-0 -mt-12 -mr-12 w-48 h-48 bg-orange-500/10 rounded-full blur-3xl group-hover:bg-orange-500/20 transition-colors" data-id="element-106" />
              <div className="flex flex-col md:flex-row items-center justify-between gap-8 relative z-10" data-id="element-107">
                <div className="text-left" data-id="element-108">
                  <div className="inline-block bg-orange-500/20 text-orange-400 px-4 py-1 rounded-full text-[10px] font-black tracking-widest mb-4 border border-orange-500/30 uppercase" data-id="element-109">
                    EL MÁS ELEGIDO ⭐
                  </div>
                  <h4 className="text-2xl md:text-3xl text-white mb-3 group-hover:text-orange-400 transition-colors font-[900] font-[Montserrat,_sans-serif]" data-id="element-110">
                    🏆 MÉTODO SILENCIO TOTAL + PROTOCOLO ANTI-RECAÍDAS
                  </h4>
                  <p className="text-base text-gray-300 mb-4 font-sans tracking-wide opacity-90" data-id="element-111">
                    5 Tomos + 4 Bonos + Blindaje 360° para la Vida en
                    Departamentos
                  </p>
                  <div className="flex items-baseline gap-4" data-id="element-112">
                    <span className="text-white/40 line-through text-lg font-bold" data-id="element-113">
                      $89.000
                    </span>
                    <span className="text-4xl md:text-5xl font-black text-orange-400 drop-shadow-[0_0_15px_rgba(255,165,0,0.4)]" data-id="element-114">
                      $27.990{' '}
                      <span className="text-lg text-orange-200/60" data-id="element-115">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48701673144537:1" className="w-full md:w-auto text-lg px-10 py-6" onClick={() => trackCheckout('MÉTODO SILENCIO TOTAL + PROTOCOLO ANTI-RECAÍDAS', 27990)} data-id="element-116">
                  QUIERO EL MÉTODO + PROTOCOLO ANTI-RECAÍDAS
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-[0.2em]" data-id="element-117">
            {[{
            icon: Lock,
            text: 'Pago 100% seguro',
            color: 'text-green-400'
          }, {
            icon: Zap,
            text: 'Acceso en 5 minutos',
            color: 'text-yellow-400'
          }, {
            icon: ShieldCheck,
            text: 'Garantía 7 días',
            color: 'text-blue-400'
          }, {
            icon: CreditCard,
            text: 'Mercado Pago | Tarjeta',
            color: 'text-purple-400'
          }].map((item, i) => <div key={i} className="flex items-center group" data-id="element-118">
                <item.icon className={`w-4 h-4 mr-3 ${item.color} drop-shadow-[0_0_8px_rgba(0,0,0,0.5)] group-hover:scale-110 transition-transform`} data-id="element-119" />
                <span className="group-hover:text-white transition-colors" data-id="element-120">
                  {item.text}
                </span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};